// extracted by mini-css-extract-plugin
export default {"heading":"JoinToGuildModal_heading__OjeYc"};